module.exports = __webpack_public_path__ + "static/img/img_tianditu.84c372ef.png";